Object.defineProperty(exports, "__esModule", {
  value: true
});

var fetchGraphQL = function fetchGraphQL(graphQLUrl, url, credentials, app, query) {
  var fetchUrl = credentials ? url.replace('//', '//' + credentials + '@') : url;
  return fetch(graphQLUrl, {
    method: 'POST',
    body: '\n\t\t\tquery{\n\t\t\t\telastic50(host: "' + fetchUrl + '"){\n\t\t\t\t\tmsearch(\n\t\t\t\t\t\tindex: "' + app + '"\n\t\t\t\t\t\tbody: ' + JSON.stringify(query.map(function (item) {
      return JSON.stringify(item);
    })) + '\n\t\t\t\t\t)\n\t\t\t\t}\n\t\t\t}\n\t\t',
    headers: {
      'Content-Type': 'application/graphql'
    }
  }).then(function (res) {
    return res.json();
  }).then(function (jsonRes) {
    return jsonRes.data.elastic50.msearch;
  }).catch(function (error) {
    console.error(error);
  });
};

exports.default = fetchGraphQL;